// import request from '../../request'
import list from '../list'

export default list('/tables')
